import { CallRoute } from '@weave/schema-gen-ts/dist/schemas/phone/callroute/v1/callroute_service.pb';
import { PhoneOverride } from '@weave/schema-gen-ts/dist/schemas/phone/override/v2/override_service.pb';
import SchemaPhoneOverrideConfigService from '@frontend/api-overrides-v2';
import { SchemaIO } from '@frontend/schema';
import { FormValues } from '@frontend/design-system';

export enum OverrideRouteType {
  CallRoute = 'callRoute',
  DeviceExtension = 'deviceExtension',
}

export type OverrideListResponse = SchemaIO<(typeof SchemaPhoneOverrideConfigService)['List']>['output'];
export type OverrideCreatePayload = SchemaIO<(typeof SchemaPhoneOverrideConfigService)['Create']>['input'];
export type OverrideUpdatePayload = SchemaIO<(typeof SchemaPhoneOverrideConfigService)['Update']>['input'];
export type PhoneOverrideType = PhoneOverride & {
  routeType?: OverrideRouteType;
};
export type CallRouteType = CallRoute;

export type SchemaFormValues = FormValues<typeof schema>;

const schema = {
  voicemailMediaId: {
    type: 'dropdown',
    required: false,
    value: '',
  },
  voicemailBoxId: {
    type: 'dropdown',
    required: false,
    value: '',
  },
  forwardingNumberId: {
    type: 'dropdown',
    required: false,
    value: '',
  },
  selectOverride: {
    type: 'radio',
    required: false,
    value: '',
  },
  addSchedule: {
    type: 'checkbox',
    required: false,
    value: false,
  },
  startDate: {
    type: 'datePicker',
    required: false,
    value: '',
  },
  startTime: {
    type: 'time',
    required: false,
    value: '',
  },
  endDate: {
    type: 'datePicker',
    required: false,
    value: '',
  },
  endTime: {
    type: 'time',
    required: false,
    value: '',
  },
  id: {
    type: 'text',
    required: false,
    value: '',
  },
} as const;
